import React, { useEffect, useState } from "react";
import { Field, Select, Skeleton } from "../../../components/ui";
import { useOrdersApi } from "../../../hooks/useOrdersApi";
import { formatDate, t } from "../../../i18n";
import { surgeryToPedido } from "../../../lib/mappers";
import { OptionCard } from "../OptionCard";
import { AppealWizard } from "../useAppealWizard";

/** Passo 1: escolhe o paciente no select e depois o pedido que será recorrido. */
export const SelectOrderStep: React.FC<{ w: AppealWizard }> = ({ w }) => {
  const { patients, surgeries, loadingPatients, patientsFailed, loadingSurgeries, fetchPatientsByDoctor, fetchSurgeriesByPatient } = useOrdersApi();
  const [patient, setPatient] = useState(w.surgery?.pacient_name ?? "");

  useEffect(() => {
    fetchPatientsByDoctor();
  }, [fetchPatientsByDoctor]);

  useEffect(() => {
    if (patient) fetchSurgeriesByPatient(patient);
  }, [patient, fetchSurgeriesByPatient]);

  const orders = [...(surgeries ?? [])]
    .filter((s) => s.pacient_name === patient)
    .sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());

  return (
    <>
      <p className="text-body text-fg-muted">{t("appeals.order.intro")}</p>
      <Field label={t("appeals.order.patient")} hint={!loadingPatients && !patientsFailed && patients.length === 0 ? t("appeals.order.noPatients") : undefined}>
        <Select value={patient} onChange={(e) => setPatient(e.target.value)} disabled={loadingPatients}>
          <option value="" disabled>
            {t(loadingPatients ? "appeals.order.loadingPatients" : "appeals.order.choosePatient")}
          </option>
          {patients.map((p) => (
            <option key={p} value={p}>
              {p}
            </option>
          ))}
        </Select>
      </Field>

      {patient &&
        (loadingSurgeries && orders.length === 0 ? (
          <div className="flex flex-col gap-2.5" aria-label={t("appeals.order.loadingOrders")}>
            <Skeleton className="h-14" />
            <Skeleton className="h-14" />
          </div>
        ) : orders.length === 0 ? (
          <p className="text-body text-fg-muted">{t("appeals.order.noOrders")}</p>
        ) : (
          <div className="stagger flex flex-col gap-2.5">
            {orders.map((s) => {
              const order = surgeryToPedido(s);
              return (
                <OptionCard
                  key={s.timestamp}
                  selected={w.surgery?.timestamp === s.timestamp}
                  onClick={() => w.selectSurgery(s)}
                  title={t("appeals.order.orderTitle", { code: order.codigo, procedure: order.procedimento })}
                  description={formatDate(s.timestamp, { dateStyle: "long" })}
                />
              );
            })}
          </div>
        ))}
    </>
  );
};
